module.exports = __webpack_public_path__ + "media/src/images/shopify-6c40d7858ef55c6d75ee47dc03125fc0.png";